<disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
<disclaimer
  [message]="'LOCATIONS.SECTOR_AND_ENVIRONMENT.LINKS_TAB_DISCLAIMER' | translate"
  [badge]="'LOCATIONS.SECTOR_AND_ENVIRONMENT.BADGE' | translate"
  icon="magic_stars"
>
</disclaimer>
<disclaimer [message]="'LOCATIONS.SECTOR_AND_ENVIRONMENT.LINKS_TAB_DISCLAIMER_2' | translate"></disclaimer>

<div class="search">
  <fc-text-input
    class="search__input"
    [control]="searchTerm"
    [label]="'LOCATIONS.DIALOG.TABS.TAB_LINKS.SEARCH' | translate"
    showSearchIcon="true"
  >
  </fc-text-input>
  <span>{{ 'LOCATIONS.DIALOG.TABS.TAB_LINKS.OR' | translate }}</span>
  <div>
    <fc-button
      [label]="'LOCATIONS.DIALOG.TABS.TAB_LINKS.ADD_LINK' | translate"
      [primary]="true"
      [large]="true"
      [menu]="menu"
      *ngIf="!isViewMode"
    >
    </fc-button>

    <mat-menu #menu="matMenu">
      <button class="button-with-icon" mat-menu-item (click)="openCreateSectorDialog()">
        <mat-icon svgIcon="sector">sector</mat-icon>
        <span>{{ 'LOCATIONS.DIALOG.TABS.TAB_LINKS.NEW_SECTOR' | translate }}</span>
      </button>
      <button class="button-with-icon" mat-menu-item (click)="openCreateEnvironmentDialog()">
        <mat-icon svgIcon="environment">environment</mat-icon>
        <span>{{ 'LOCATIONS.DIALOG.TABS.TAB_LINKS.NEW_ENVIRONMENT' | translate }}</span>
      </button>
      <button class="button-with-icon" mat-menu-item (click)="openCreateEquipmentDialog()">
        <mat-icon svgIcon="equipment">equipment</mat-icon>
        <span>{{ 'LOCATIONS.DIALOG.TABS.TAB_LINKS.NEW_EQUIPMENT' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>

<h2 class="title">{{ 'LOCATIONS.DIALOG.TABS.TAB_LINKS.LINKS_ON_THIS_LOCATION' | translate }}</h2>

<div class="tree" *ngIf="!isEmpty && !isLoading">
  <div class="tree__node" *ngFor="let sector of locationLinks">
    <fc-tree-view [item]="sector"></fc-tree-view>
  </div>

  <div class="tree__node" *ngFor="let equipment of unlinkedEquipments">
    <fc-tree-view [item]="equipment"></fc-tree-view>
  </div>
</div>

<div class="tree-empty" *ngIf="isEmpty && !isLoading">
  {{ 'LOCATIONS.SECTOR_AND_ENVIRONMENT.EMPTY_LINKS' | translate }}
</div>

<div class="tree-skeleton" *ngIf="isLoading">
  <div class="tree-skeleton__node" *ngFor="let item of [].constructor(5)">
    <ngx-skeleton-loader *ngFor="let item of [].constructor(10)" [theme]="{ height: '34px' }"></ngx-skeleton-loader>
  </div>
</div>
